import join from 'url-join';
import { OptimizelyDecideOption as Options } from '@optimizely/optimizely-sdk';
import { Cookie, useOptimizely } from '@libs/common-next';
import { useOverrides } from '../../store';
import type { Flag } from '../../types';

export function useFlag(flag: Flag) {
    const { context, instance } = useOptimizely();
    const { overrides, setOverride } = useOverrides();
    const original = context?.decide(flag.key, [Options.DISABLE_DECISION_EVENT])?.variables.value;

    return {
        value: overrides[flag.key] ?? original,
        onChange(newV: string | boolean) {
            const value = { ...overrides, [flag.key]: newV };
            if (newV === original) delete value[flag.key];

            Cookie.set('x-petm-override', JSON.stringify(value));
            setOverride(value);
        },
        disabled: flag.options.length < 2,
        isOverride: Object.keys(overrides).includes(flag.key),
        link: join(
            'https://app.optimizely.com/v2/projects',
            `${instance?.getProjectConfig()?.projectId}`,
            '/flags/manage',
            flag.key,
            '/variations'
        ),
    };
}
